export enum ECargoTransporterUserState {    
    Unblocked,
    Blocked
}